// src/assets/theme/theme.js

// Safe window dimension lookup for web
const getDimensions = () => {
  if (typeof window !== 'undefined') {
    return {
      width: window.innerWidth,
      height: window.innerHeight,
    };
  }
  return { width: 375, height: 812 }; // Default mobile fallback for SSR
};

const { width, height } = getDimensions();

export const theme = {
  colors: {
    // BRAND IDENTITY
    brand: '#E9001E',
    primaryRed: '#B52A1F',
    darkRed: '#8C1F16',
    brandTint: '#F9E4E2',

    // STRUCTURAL UI
    bitumen: '#2B2A29',
    blueOxide: '#0F4392',
    charcoal: '#1C2833',
    steelBlue: '#2E4057',
    concrete: '#707B8C',
    limestone: '#E8E0D0',
    offWhite: '#F5F3EF',

    // GREYSCALE
    pureWhite: '#FFFFFF',
    grey001: '#FCF8F8',
    grey002: '#CBD5E1',
    grey003: '#636C78',
    grey004: '#C4C4C4',
    grey005: '#D9DDDE',

    // SEMANTIC STATUS
    success: '#1E8449',
    warning: '#C47A00',
    error: '#FF3D07',
    information: '#1A5E8A',
    gold: '#FFC004',
  },

  gradients: {
    red: ['rgb(140, 31, 22)', 'rgb(233, 0, 30)'],
    blue: ['rgb(26, 94, 138)', 'rgb(46, 157, 244)'],
    green: ['rgb(30, 132, 73)', 'rgb(104, 225, 5)'],
    yellow: ['rgb(196, 122, 0)', 'rgb(252, 196, 23)'],
    warning: ['rgb(255, 61, 7)', 'rgb(255, 98, 243)'],
  },

  spacing: {
    0: 0,
    50: 4,
    100: 8,
    150: 12,
    200: 16,
    300: 24,
    400: 32,
    500: 40,
    600: 48,
  },

  radius: {
    0: 0,
    8: 8,
    12: 12,
    16: 16,
    24: 24,
    999: 999,
  },

  shadows: {
    cardShadow: {
      boxShadow: '0px 4px 4px rgba(12, 12, 13, 0.1)',
    },
    fieldShadow: {
      boxShadow: '0px 1px 4px rgba(12, 12, 13, 0.1)',
    },
    cardShadow2: {
      boxShadow: '12px 12px 16px rgba(234, 234, 234, 0.25)',
    },
    dropShadow: {
      boxShadow: '0px 4px 4px rgba(12, 12, 13, 0.1)',
    },
    overlay: {
      boxShadow: '0px 16px 40px rgba(0, 0, 0, 0.15)',
    },
  },

typography: {
    displayXL: { fontFamily: '"Barlow Condensed", sans-serif', fontWeight: 700, fontSize: '28px', letterSpacing: '0px' },
    headingLG: { fontFamily: '"Barlow Condensed", sans-serif', fontWeight: 600, fontSize: '22px', letterSpacing: '0px' },
    headingMD: { fontFamily: '"DM Sans", sans-serif', fontWeight: 600, fontSize: '17px', letterSpacing: '0px' },
    bodyLG: { fontFamily: '"DM Sans", sans-serif', fontWeight: 500, fontSize: '15px', letterSpacing: '0px' },
    bodyLGSingle: { fontFamily: '"DM Sans", sans-serif', fontWeight: 400, fontSize: '15px', letterSpacing: '0px' },
    bodyMD: { fontFamily: '"DM Sans", sans-serif', fontWeight: 400, fontSize: '13px', letterSpacing: '0px' },
    bodySM: { fontFamily: '"DM Sans", sans-serif', fontWeight: 400, fontSize: '11px', letterSpacing: '0px' },
    monoLG: { fontFamily: '"DM Mono", monospace', fontWeight: 500, fontSize: '15px', letterSpacing: '0px' },
    monoMD: { fontFamily: '"DM Mono", monospace', fontWeight: 400, fontSize: '13px', letterSpacing: '0px' },
    buttonMD: { fontFamily: '"DM Sans", sans-serif', fontWeight: 500, fontSize: '15px', lineHeight: '15px', letterSpacing: '0px' },
    buttonSM: { fontFamily: '"DM Sans", sans-serif', fontWeight: 500, fontSize: '13px', lineHeight: '13px', letterSpacing: '0px' },
  },

  dimensions: {
    screenWidth: width,
    screenHeight: height,
  },
};